import React from 'react';
import { ChevronRight, ShoppingCart, TrendingUp, TrendingDown } from 'lucide-react';

const MonthlySummary = ({ data, onMonthClick, previousData }) => {
  if (!data || data.length === 0) {
    return (
      <div className="summary-empty">
        <ShoppingCart size={40} color="#333" />
        <p>No expenses recorded yet.</p>
        <p className="summary-empty-sub">Upload your first receipt to get started.</p>
      </div>
    );
  }

  return (
    <div className="monthly-grid">
      {data.map((month) => {
        const prev = previousData?.find(p => p.month_key !== month.month_key);
        const trend = prev ? ((month.total - prev.total) / prev.total) * 100 : null;

        return (
          <button key={month.month_key}
            className="month-card"
            onClick={() => onMonthClick(month)}>
            <div className="month-card-top">
              <div className="month-label">
                <p className="month-name">{month.month_name}</p>
                <p className="month-year">{month.year}</p>
              </div>
              <ChevronRight size={18} color="#555" />
            </div>

            <p className="month-total">${month.total.toFixed(2)}</p>

            <div className="month-stats">
              <div className="month-stat">
                <ShoppingCart size={13} />
                <span>{month.visit_count} {month.visit_count === 1 ? 'visit' : 'visits'}</span>
              </div>
              {trend !== null && (
                <div className={`month-trend ${trend > 0 ? 'trend-up' : 'trend-down'}`}>
                  {trend > 0
                    ? <TrendingUp size={13} />
                    : <TrendingDown size={13} />
                  }
                  <span>{Math.abs(trend).toFixed(0)}% vs prev</span>
                </div>
              )}
            </div>

            {/* Spending bar */}
            <div className="month-bar-track">
              <div className="month-bar-fill"
                style={{
                  width: `${Math.min(100, (month.total / Math.max(...data.map(d => d.total))) * 100)}%`
                }}
              />
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default MonthlySummary;
